import { useQuery } from '@apollo/client/react';
import { PromptFormDialogDocument } from './PromptFormDialog.gql';
export function useGetLabels() {
    const { data, error, loading } = useQuery(PromptFormDialogDocument);
    const { documentAssistantPrompts } = data || {};
    const prompts = (documentAssistantPrompts === null || documentAssistantPrompts === void 0 ? void 0 : documentAssistantPrompts.items) || [];
    const allLabels = prompts.flatMap((prompt) => prompt.labels);
    return {
        data: allLabels,
        error,
        loading,
    };
}
